{
  "deleteProrationTitle": "Eliminar prorrateo",
  "deleteProrationMessage": "¿Está seguro de que desea eliminar este prorrateo?",
  "requiredField": "Campo requerido",
  "title": "Ordenes",
  "overview": "Visión General",
  "order-flow": "Flujo de orden",
  "messages": "Mensage",
  "documents": "Documentos",
  "notes": "Notas",
  "parties": "Involucrados",
  "order": "Orden",
  "properties": "Propiedades",
  "loans": "Prestamos",
  "payoffs": "Pagos",
  "loan-amount": "Monto del préstamo",
  "property": "Propiedad",
  "status": "Estado",
  "loan-number": "Numero de préstamo",
  "active": "Activo",
  "all-orders": "Todas las Ordenes",
  "in-progress": "En Progreso",
  "on-hold": "En Espera",
  "create-order": "Crear Nueva Orden",
  "active-orders": "Ordenes Activas",
  "order-id": "Orden ID",
  "address": "Domicilio",
  "state": "Estado",
  "city": "Ciudad",
  "lender": "Prestador",
  "transaction-type": "Transaccion",
  "type": "Tipo",
  "closing-date": "Fecha de Cierre",
  "licenses": "licencias",
  "create-order-leme": "Por favor, seleccione la configuración que necesita para este contrato.",
  "no-orders-yet": "No existen órdenes creadas aun",
  "please-create-order": "por favor, crea una orden para comenzar",
  "not-orders-open": "Aun No hay Ordenes Abiertas",
  "date-and-config": "Fecha y configuración",
  "amounts": "Cantidades",
  "property-information": "Información de la propiedad",
  "legal-description": "Descripción legal",
  "subdivisions": "Subdivisiones",
  "survey": "Encuesta",
  "attorney": "Abogado",
  "spouse": "Esposo (a)",
  "property-description": "Descripción legal de la propiedad",
  "acceptance-date": "Fecha de aceptacion",
  "disbursement-date": "Disbursement Date",
  "purchase-price": "Precio de compra",
  "load-amount": "Monto del préstamo",
  "open": "Abierto",
  "add-new-employee": "Agregar nuevo empleado",
  "create-associate-modal-create-associate": "Crear nuevo empleado",
  "apt-suite-etc": "apartamento, suite, etc…",
  "subdivision": "subdivisión",
  "section": "seccion",
  "block": "bloque",
  "lot": "lote",
  "township": "suburbio",
  "complete-all-fields": "Porfavor complete todos los campos y presione guardar",
  "range": "rango",
  "property-type": "tipo de propiedad",
  "municipal-jurisdiction": "jurisdiccion municipal",
  "parcel": "parcela",
  "add-parcel": "agregar parcela",
  "corporation": "Corporación",
  "limit-liability-company": "Compañía de responsabilidad limitada",
  "estate": "Inmuebles",
  "trust": "Confianza",
  "partnertship": "Camaradería",
  "guardianship": "Tutela",
  "settlement-statement": "Liquidación",
  "order-menu": "Menú de Ordenes",
  "parties-involved": "Partes Involucradas",
  "openedBy": "Abierto por",
  "not-defined-yet":"Aún no definido",
  "purchase":"Compra",
  "refinance":"Refinanciamiento",
  "heloc":"HELOC",
  "questions-and-answers": "Preguntas y respuestas",
  "narrative": "Narrativa",
  "orders-from": "Ordenes de ",
  "funding-date": "Fecha de financiación",
  "please-select-order":"Seleccione una agencia en su perfil antes de crear un nuevo pedido.",
  "information-from-document":"Información recogida del documento",
  "please-check-before":"Por favor revise antes de crear el pedido. Puede hacer cambios en este pedido más adelante.",
  "closed": "Cerrado",
  "hold": "En espera",
  "cancelled": "Cancelado",
  "table": "Tabla",
  "map": "Mapa",
  "view": "Vista",
  "propertyLabel": "Propiedad",
  "kindLabel": "Tipo",
  "typeLabel": "Tipo",
  "perDiemLabel": "Por Día",
  "amountLabel": "Monto",
  "propertiesLabel": "Propiedades",
  "kindToChangeLabel": "Tipo a Cambiar",
  "newKindLabel": "Nuevo Tipo",
  "descriptionLabel": "Descripción",
  "partyLabel": "Parte",
  "signerLabel": "Firmante",
  "startLabel": "Inicio",
  "endLabel": "Fin",
  "selectPartyLabel": "Seleccione la parte",
  "selectDocumentLabel": "Seleccionar Documento",
  "criticalLabel": "Crítico",
  "resolvedLabel": "Resuelto",
  "commentsLabel": "Comentarios",
  "totalLabel": "Total",
  "briefLegalDescriptionLabel": "Breve Descripción Legal",
  "hideTaxLabel": "Ocultar Impuesto",
  "selectPayeePayerTitle": "Seleccionar Beneficiario(s) y Pagador(es)",
  "payeeLabel": "Beneficiario",
  "payerLabel": "Pagador",
  "expectedPaymentLabel": "Pago Esperado",
  "editEntryButton": "Editar Entrada",
  "deleteEntryButton": "Eliminar Entrada",
  "changePayeesButton": "Cambiar Beneficiario(s)",
  "changePayersButton": "Cambiar Pagador(es)",
  "entryActionsLabel": "Acciones de la entrada",
  "associationDeletedMessage": "Asociación Eliminada",
  "deletingMessage": "Eliminando",
  "chargesUpdatedMessage": "Cargos Actualizados",
  "updatingMessage": "Actualizando...",
  "notDefinedYetLabel": "Aún no definido",
  "chargesTitle": "Cargos",
  "tutorialTooltip": "Tutorial",
  "deleteChargeTitle": "Eliminar Cargo",
  "deleteChargeConfirmation": "¿Está seguro de que desea eliminar el cargo con la descripción \"{{description}}\"? \nEsta acción no se puede deshacer y se perderá toda la información asociada.",
  "deleteChargeGenericConfirmation": "¿Está seguro de que desea eliminar este cargo? Esta acción no se puede deshacer y se perderá toda la información asociada.",
  "confirmButton": "Confirmar",
  "payeesLabel": "Beneficiarios",
  "payersLabel": "Pagadores",
  "taxesLabel": "Impuestos",
  "atClosingLabel": "Al Cierre",
  "beforeClosingLabel": "Antes del Cierre",
  "deleteDocumentTooltip": "Eliminar documento",
  "editDocumentTooltip": "Editar documento",
  "editPremiumLineButton": "Editar línea de prima en información de póliza",
  "paidByBorrowerLabel": "Pagado por el Prestatario",
  "paidBySellerLabel": "Pagado por el Vendedor",
  "orderTab": "Orden",
  "informationTab": "Información de Contacto",
  "changeContactKindsButton": "Cambiar roles",
  "optionsTitle": "Opciones",
  "relationsTitle": "Relaciones",
  "byRoleTab": "Por Rol",
  "byNameTab": "Por Nombre",
  "othersTab": "Otras Partes",
  "willHaveLabel": "Tendrá",
  "asLabel": "Como",
  "selectNewKindTitle": "Seleccione un Nuevo Tipo para Reemplazar el Actual",
  "partyNotInvolvedTitle": "Parte no involucrada",
  "partyNotInvolvedMessage": "No está involucrado en la orden, esto se puede cambiar en la pantalla de Partes.",
  "goToPartiesButton": "Ir a Partes",
  "partiesLabel": "Partes",
  "attendeesLabel": "Asistentes",
   "receptionsTitle": "Recepciones",
   "textTab": "Texto",
   "htmlTab": "HTML",
   "rawMessageTitle": "Mensaje sin procesar",
   "noReceptionInfo": "No hay información de recepciones disponible",
   "orderNotesTitle": "Notas de Orden",
   "newNoteButton": "Nueva Nota",
   "newUpdateTitle": "Nueva Actualización",
   "newNoteTitle": "Nueva Nota",
   "closeButton": "Cerrar",
   "acceptButton": "Aceptar",
   "deleteNoteTitle": "¿Está seguro de que desea eliminar esta Nota?",
   "deleteNoteSubtitle": "Esta acción eliminará permanentemente esta nota y no se puede deshacer. ¿Desea continuar?",
   "deleteNoteCancelButton": "No, Mantener Nota",
   "deleteNoteConfirmButton": "Sí, Eliminar Nota",
   "deleteNoteAria": "Eliminar nota",
   "editNoteAria": "Editar nota",
   "readMore": "Leer más",
   "readLess": "Mostrar menos",
   "notesLoadingLabel": "Cargando notas...",
   "noNotesTitle": "Sin notas aún",
   "noNotesMessage": "No se han creado notas para esta orden aún. Cree una nueva nota para comenzar.",
  "actionsLabel": "Acciones",
  "noLoansMessage": "Aún no se han agregado préstamos",
  "daysPerYear360Label": "360 días por año",
  "daysPerYear365Label": "365 días por año",
  "daysPerYear366Label": "366 días por año",
  "prorationDateWarningMessage": "La Fecha de Prorrateo no está en el rango de la Fecha de Inicio del Período y la Fecha de Fin del Período",
  "periodStartDateLabel": "Fecha de Inicio del Período",
  "periodEndDateLabel": "Fecha de Fin del Período",
  "createProrationTitle": "Crear Prorrateo",
  "installmentOption": "Cuota",
  "perDiemOption": "Por Día",
  "basicOption": "Básico",
  "taxOption": "Impuesto",
  "createButton": "Crear",
  "noPropertyMessage": "Aún no hay propiedades.",
  "goToProperties": "Ir a Propiedades",
  "rateLabelInterest": "Tasa",
  "indexNameLabel": "Nombre del Índice",
  "marginLabel": "Margen",
  "feeLabel": "Tarifa",
  "periodStartLabel": "Inicio del Período",
  "periodEndLabel": "Fin del Período",
  "changeDateLabel": "Fecha de Cambio",
  "changeMinLabel": "Cambio Mínimo",
  "changeMaxLabel": "Cambio Máximo",
  "monthsLabel": "Meses",
  "rateMinLabel": "Tasa Mínima",
  "rateMaxLabel": "Tasa Máxima",
  "gracePeriodDaysLabel": "Días de Período de Gracia",
  "decimalsLabel": "Decimales",
  "createLinkToEntryTitle": "Crear Enlace a entrada",
  "selectEntryLabel": "Seleccionar entrada",
  "selectAssociationLabel": "Seleccionar asociación",
  "createLinkButton": "Crear un Enlace",
  "selectColumnToFilterLabel": "Seleccionar Columna para filtrar",
  "selectTypeOfFilterLabel": "Seleccionar Tipo de Filtro",
  "searchLabel": "Buscar",
  "applyFilterButton": "Aplicar filtro",
  "clearResultsButton": "Limpiar Resultados",
  "beforeClosingHeader": "Antes del Cierre",
  "atClosingHeader": "Al Cierre",
  "paymentIdHeader": "ID de Pago",
  "accountedByHeader": "Contabilizado Por",
  "numberHeader": "No.",
  "authorizationsLabel": "Autorizaciones",
  "searchMembersPlaceholder": "Buscar miembros...",
  "viewChainButton": "Ver Cadena",
  "loanFundingTitle": "Financiamiento del Préstamo",
  "loanAmountTitle": "Monto del Préstamo",
  "netFundedTitle": "Financiado Neto",
  "lenderCreditsTitle": "Créditos del Prestamista",
  "paidByOthersTitle": "Pagado por Otros",
  "lenderChargesTitle": "Cargos del Prestamista",
  "aggregateAdjustmentTitle": "Ajuste Agregado",
  "totalDebitAmountTitle": "Monto Total de Débito",
  "totalCreditAmountTitle": "Monto Total de Crédito",
  "totalBalanceTitle": "Balance total",
  "balancedLabel": "Balanceado",
  "overdisbursedLabel": "Sobredesembolsado",
  "underfundedLabel": "Subfinanciado",
  "cashOnlyTooltip": "El valor de solo efectivo ahora se determinará automáticamente según si hay préstamos presentes en la orden.",
  "cashOnlyOrderMessage": "Esta es una orden solo en efectivo",
  "notCashOnlyOrderMessage": "Esta no es una orden solo en efectivo",
  "noDataFoundMessage": "No se encontraron datos",
  "goToPropertiesButton": "Ir a Propiedades",
  "percentLabel": "Porcentaje",
  "accountingBalancesTitle": "Balances contables",
  "order-information": "Información de la Orden",
  "dates-information": "Información de Fechas",
  "addendums-k": "Adendos K",
  "addendums-m": "Adendos M",
  "addendums-l": "Adendos L",
  "addendums-n": "Adendos N",
  "actual": "Real",
  "disclosed": "Divulgado",
  "order-updated": "Orden Actualizada",
  "updating": "Actualizando...",
  "note-by": "por {{name}}",
  "note-on": "en {{date}}",
  "orderPartiesListTitle": "Lista de Partes de la Orden",
  "parcelIdTitle": "{{parcel}} ID",
  "memberKindOn": "{{kind}} en {{name}}",
  "noMortgageMessage": "Aún no se han añadido pagos de hipotecas",
  "prorated-amount": "Cantidad prorrateada",
  "proratedAmountWarningMessage": "Al modificar el monto prorrateado, los cálculos predefinidos cambiarán.",
  "ownership": "Propiedad",
  "current-owners": "Propietario(s) actual(es)",
  "new-owners": "Nuevo(s) propietario(s)",
  "split-current-owners": "Dividir entre propietario(s) actual(es)",
  "split-new-owners": "Dividir entre nuevo(s) propietario(s)"
}
